module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v(_vm._s(_vm.server.fqdn) + " ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v(_vm._s(_vm.server.description))]), _vm._v(" "), _c('el-tabs', {
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('tab.dashboard')
    }
  }, [_c('dashboard')], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('tab.settings')
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24,
      "sm": 12
    }
  }, [_c('server-settings', {
    attrs: {
      "server": _vm.server
    }
  }), _vm._v(" "), _c('licence-uploader', {
    attrs: {
      "server": _vm.server
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.childServers.length) ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('tab.child-servers')
    }
  }, [_c('server-list', {
    attrs: {
      "servers": _vm.childServers
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-44b0bba0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/server/ServerDetails.vue
// module id = 1150
// module chunks = 2